import { Badge } from "@shared/components/ui/badge";
import { CheckCircle, Clock, XCircle, Minus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { BANKING_STATUS, BANKING_STATUS_COLORS } from "@shared/utils/constants";

const BankingStatus = ({ status, className = "" }) => {
  const { t } = useTranslation();

  const getStatusConfig = (status) => {
    switch (status) {
      case BANKING_STATUS.VALIDATED:
        return {
          label: t("banking.approved"),
          variant: "success",
          icon: CheckCircle,
          className: BANKING_STATUS_COLORS.validated,
        };
      case BANKING_STATUS.PENDING:
        return {
          label: t("banking.pending"),
          variant: "warning",
          icon: Clock,
          className: BANKING_STATUS_COLORS.pending,
        };
      case BANKING_STATUS.REJECTED:
        return {
          label: t("banking.rejected"),
          variant: "destructive",
          icon: XCircle,
          className: BANKING_STATUS_COLORS.rejected,
        };
      default:
        return {
          label: t("banking.notSubmitted"),
          variant: "secondary",
          icon: Minus,
          className: BANKING_STATUS_COLORS.not_set,
        };
    }
  };

  const config = getStatusConfig(status);
  const Icon = config.icon;

  return (
    <Badge 
      variant={config.variant} 
      className={`inline-flex items-center gap-1.5 ${config.className} ${className}`}
    >
      <Icon className="w-3 h-3" />
      {config.label}
    </Badge>
  );
};

export default BankingStatus;